import { useParams } from "react-router-dom";
import CustomViewRenderer from "@webcore/components/domain/dashboard/renderers/custom/CustomViewRenderer.tsx";
import { OpsAppPlatformProvider } from "@webcore/context-providers/OpsAppPlatformProvider.tsx";
import { useMfeSession } from "@/components/MfeBootstrap.tsx";

/**
 * Ops route for a custom dashboard view. Reads the view identifiers from the path, provides the ops
 * app platform (user context, objects, documents) for that pipeline configuration, and renders the
 * shared CustomViewRenderer against the session established by MfeBootstrap — whose token exchange
 * supplied the user context. The ops app is the platform provider for custom views: the
 * capabilities view code receives are mounted here.
 */
function OpsCustomViewRoute() {
  const { userContext } = useMfeSession();
  const { dashboardId, viewId, dataPipelineConfigurationId } = useParams<{
    dashboardId: string;
    viewId: string;
    dataPipelineConfigurationId: string;
  }>();

  if (dashboardId === undefined || viewId === undefined || dataPipelineConfigurationId === undefined) {
    return <div className="text-danger p-3">Missing view parameters.</div>;
  }

  return (
    <OpsAppPlatformProvider dataPipelineConfigurationId={dataPipelineConfigurationId} userContext={userContext}>
      <CustomViewRenderer
        dashboardId={dashboardId}
        viewId={viewId}
        dataPipelineConfigurationId={dataPipelineConfigurationId}
      />
    </OpsAppPlatformProvider>
  );
}

export default OpsCustomViewRoute;
